<template>
  <div class="bto-sb-element">
    <div v-if="checkProvider(BETRADAR)" :id="betradarContainerId"></div>
    <div
      v-if="checkProvider(STATSCORE) && !statscoreError"
      class="STATSCORE__Tracker"
      :id="`Tracker-${betRadarId}`"
      :data-event="betRadarId"
      :data-lang="statscoreLang"
      :data-config="statscoreConfigId"
      data-zone=""
      data-use-mapped-id="1"></div>
    <div v-if="checkProvider(STATSCORE_V3) && !statscoreError" ref="trackerEl"></div>
  </div>
</template>

<script>
  import { TRACKING_PROVIDERS } from '../../../models/trackers';
  import { fetchResource } from '../../../services/utils';
  const { STATSCORE, BETRADAR, STATSCORE_V3 } = TRACKING_PROVIDERS;

  export default {
    name: 'PrematchTrackerComponent',
    data() {
      return {
        STATSCORE,
        BETRADAR,
        STATSCORE_V3,
        provider: APP_SETTINGS.statistics.provider,
        statscoreLang: this.$root.statscoreLang,
        statscoreConfigId: APP_SETTINGS.statistics.statscoreConfigId,
        betradarContainerId: 'bto-sb-live-tracker',
        statscoreError: false,
        st3Widget: null,
        iframeHeight: '',
      };
    },
    props: {
      betRadarId: {
        type: [Number, String],
        required: true,
        default: 0,
      },
      feedProvider: {
        type: String,
      },
      isAwayAtHome: {
        type: Boolean,
        default: false,
      },
    },
    mounted() {
      this.setupTrackers();
    },
    methods: {
      /**
       * Get and initialize live tracker based on set provider
       */
      setupTrackers() {
        switch (this.provider) {
          case BETRADAR:
            this.setupBetradar();
            return;
          case STATSCORE:
            this.setupStatscore();
            return;
          case STATSCORE_V3:
            this.setupStatscoreV3();
            return;
          default:
            console.error('no provider set for live tracker'); // eslint-disable-line
            return;
        }
      },
      /**
       * Get statscore script if not preset,then initalize the live tracker
       */
      setupStatscore() {
        const statscoreUrl = 'https://live.statscore.com/livescorepro/generator';
        fetchResource('script', 'bto-sb-lmt-st', { async: true, src: statscoreUrl }).then(this.initStatscore);
      },
      setupStatscoreV3() {
        const statscoreV3Url = 'https://wgt-s3-cdn.statscore.com/bundle/Embeder.js';
        fetchResource('script', 'bto-statscore-v3', { async: true, src: statscoreV3Url }).then(this.initStatscoreV3);
      },
      /**
       * Initalize statscore live tracker
       */
      initStatscore() {
        // Script for statscore is not present exit
        if (typeof window['Softnetsport'] === 'undefined') {
          return;
        }
        if (typeof this.$root.statscore !== 'object' || Object.keys(this.$root.statscore).length === 0) {
          this.$root.statscore = new window.Softnetsport.LSP.Generator();
        }
        window.addEventListener('message', this.statscoreErrorHandler);
        // init statscore live tracker
        this.$root.statscore.addTrackersEmbeddedOnPage();
      },
      initStatscoreV3() {
        // If script is not initialized load default values on window object
        if (!window.STATSCOREWidgets) {
          window.STATSCOREWidgets = {};
          window.STATSCOREWidgets.onLoadCallbacks = [];
          window.STATSCOREWidgets.onLoad = function (d) {
            window.STATSCOREWidgets.onLoadCallbacks.push(d);
          };
        }

        window.STATSCOREWidgets.onLoad(err => {
          if (err) {
            this.statscoreError = true;
            return;
          }

          const element = this.$refs.trackerEl;

          // Configuration that you should receive from STATSCORE
          const configurationId = APP_SETTINGS.statistics.statscoreConfigId;

          // Feed Provider Codes
          // Betgenius 'bg' - 109
          // Betradar 'sr' - 11
          const providerCode = this.feedProvider === 'bg' ? 109 : 11;

          //Language Code
          const language = window.sportCastCulture == 'pt-BR' ? 'br' : APP_SETTINGS.player.language
      
          // Input data for widget type you want to embded
          const inputData = { eventId: `m:${this.betRadarId}`, providerId: providerCode, language: language, invertedParticipants: this.isAwayAtHome };

          // Optional object with options.
          // You can check available options further in the docs.
          const options = { loader: { enabled: true } };

          this.st3Widget = new window.STATSCOREWidgets.WidgetGroup(element, configurationId, inputData, options);
          this.st3Widget.on('error', () => {
            this.statscoreError = true;
          });
        });
      },
      /**
       * Get betradar script if not present,then initalize the live tracker
       */
      setupBetradar() {
        let brClient = APP_SETTINGS.liveTracker.brliveclient;
        let lang = APP_SETTINGS.player.language;

        let liveTrackerUrl = `//cs.betradar.com/ls/widgets/?/${brClient}/${lang}/widgetloader/widgets`;
        fetchResource('script', 'bto-sb-lmt-br', { async: true, src: liveTrackerUrl }).then(this.initBetradar);
      },
      /**
       * Initalize betradar live tracker
       */
      initBetradar() {
        // Script for betradar is not present exit
        if (typeof SRLive === 'undefined') {
          return;
        }
        let timeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone.replace('/', ':');
        if (typeof timeZoneName === 'undefined' || timeZoneName === '') {
          timeZoneName = 'Europe:Berlin';
        }
        setTimeout(() => {
          SRLive.changeTimezone(timeZoneName);
          this.liveTrackerId = SRLive.addWidget({
            widget: {
              applyIEClass: true,
              rootRewritten: false,
              hostMapped: false,
            },
            name: 'widgets.lmts',
            config: {
              container: `#${this.betradarContainerId}`,
              matchId: this.betRadarId,
              collapse_startCollapsed: APP_SETTINGS.liveTracker.startCollapsed || false,
            },
          });
        });
      },

      /**
       * Check if given provider is the active provider
       * @param {string} provider - Provider to check
       */
      checkProvider(provider) {
        return this.provider === provider;
      },
      statscoreErrorHandler(event) {
        if (event.origin !== 'https://live.statscore.com') {
          return;
        }
        if (event.data.type === 'statscore.livematchpro.error') {
          this.statscoreError = true;
        }
      },
      removeStatscoreErrorListener() {
        window.removeEventListener('message', this.statscoreErrorHandler);
      },
    },
    beforeDestroy() {
      if (this.provider === STATSCORE_V3 && this.st3Widget) {
        this.st3Widget.destroy();
        this.st3Widget = null;
      }
      if (this.provider === STATSCORE) {
        this.removeStatscoreErrorListener();
      }
      if (typeof SRLive !== 'undefined') {
        SRLive.removeWidget(this.liveTrackerId);
      }
    },
  };
</script>
